import { useState, useEffect } from 'react';
import { ButtonBasic, DropDownSelector } from '@lk-gtcom/ecomlab-components';
import './ModalAddToGroup.scss';
import { KonstantinFeedbackHttps } from '../../../fetchUrls';
import useGeneralStore from '../../../store/general';
import customHeaders, { getSpace } from '../../../common/headers';
import { ModalComponent } from '../ModalComponent/ModalComponent';
import { useResponseHandler } from '../../../common/auth';

const ModalAddToGroup = ({
  setIsModal,
  setArrCheck,
  addToGroupTemplate,
  selectedGroupId,
  page
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [optionsGroup, setOptionsGroup] = useState([]);

  const current_prop = optionsGroup.filter(
    ({ label, value }) => selectedGroupId != value
  );

  const fetchGroupList = () => {

    let query = '';
    let url = `${KonstantinFeedbackHttps}/${page}/answers/groups${query}`;


    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => {
        const transformedGroups = json.map((group) => ({
          label: group.group_name,
          value: group.id,
        }));
        setOptionsGroup(transformedGroups);
      })
      .catch(handleRequestError);
  };

  useEffect(() => {
    fetchGroupList();
  }, []);

  return (
    <ModalComponent
      title='Добавить в:'
      onClose={(e) => setIsModal(false)}
      style={{
        height: 'auto',
        maxWidth: '500px',
        overflow: 'visible'
      }}
      styleContent={{
        overflow: 'visible'
      }}
      child={
        <div className="modal-add-to-group">
          <DropDownSelector
            width="100%"
            options_prop={current_prop}
            state={selectedGroup}
            setState={setSelectedGroup}
            placeholder="Выберите группу"
            maxWidth='100%'
          />

          <ButtonBasic
            green
            text="Переместить"
            onClick={(e) => {
              addToGroupTemplate(selectedGroup?.value);
              setArrCheck([]);
              setIsModal(false);
            }}
          />
        </div>
      }
    />

  );
};

export { ModalAddToGroup };
